import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=7d4f2e24&scoped=true&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=7d4f2e24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f2e24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4f2e24')) {
      api.createRecord('7d4f2e24', component.options)
    } else {
      api.reload('7d4f2e24', component.options)
    }
    module.hot.accept("./ProductSelector.vue?vue&type=template&id=7d4f2e24&scoped=true&", function () {
      api.rerender('7d4f2e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductSelector.vue"
export default component.exports